import React, { useState } from 'react';
import { Link } from 'gatsby';
import moment from 'moment';
import styles from './PhotographFeed.module.scss';

const GridIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
    <rect x="3" y="3" width="7" height="7" rx="1.5" />
    <rect x="14" y="3" width="7" height="7" rx="1.5" />
    <rect x="3" y="14" width="7" height="7" rx="1.5" />
    <rect x="14" y="14" width="7" height="7" rx="1.5" />
  </svg>
);

const FeedIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
    <rect x="4" y="4" width="16" height="5" rx="1.5" />
    <rect x="4" y="13" width="16" height="7" rx="1.5" />
  </svg>
);

const PhotographFeed = ({ edges }) => {
  const [view, setView] = useState('feed');

  return (
    <div className={styles['photographFeed']}>
      <div className={styles['photographFeed__header']}>
        <div className={styles['photographFeed__viewToggle']}>
          <button
            className={`${styles['photographFeed__viewBtn']} ${view === 'grid' ? styles['photographFeed__viewBtn--active'] : ''}`}
            onClick={() => setView('grid')}
            aria-label="Grid view"
          >
            <GridIcon />
          </button>
          <button
            className={`${styles['photographFeed__viewBtn']} ${view === 'feed' ? styles['photographFeed__viewBtn--active'] : ''}`}
            onClick={() => setView('feed')}
            aria-label="Feed view"
          >
            <FeedIcon />
          </button>
        </div>
      </div>

      {view === 'grid' ? (
        <div className={styles['photographFeed__grid']}>
          {edges.map((edge) => {
            const { photographImage, caption, date } = edge.node.frontmatter;
            const { slug } = edge.node.fields;
            return (
              <div key={slug} className={styles['photographFeed__gridItemWrapper']}>
                <div className={styles['photographFeed__gridMeta']}>
                  {caption && (
                    <span className={styles['photographFeed__gridCaption']}>{caption}</span>
                  )}
                  <time className={styles['photographFeed__gridDate']}>
                    {moment(date).format('MMMM D, YYYY')}
                  </time>
                </div>
                <Link to={slug} className={styles['photographFeed__gridItem']}>
                  <img
                    src={photographImage}
                    alt={caption || ''}
                    className={styles['photographFeed__gridImg']}
                    loading="lazy"
                  />
                </Link>
              </div>
            );
          })}
        </div>
      ) : (
        <div className={styles['photographFeed__feed']}>
          {edges.map((edge) => {
            const { photographImage, caption, date } = edge.node.frontmatter;
            const { slug } = edge.node.fields;
            return (
              <div key={slug} className={styles['photographFeed__feedItem']}>
                <div className={styles['photographFeed__feedMeta']}>
                  {caption && (
                    <span className={styles['photographFeed__feedCaption']}>{caption}</span>
                  )}
                  <time className={styles['photographFeed__feedDate']}>
                    {moment(date).format('MMMM D, YYYY')}
                  </time>
                </div>
                <Link to={slug}>
                  <img
                    src={photographImage}
                    alt={caption || ''}
                    className={styles['photographFeed__feedImg']}
                    loading="lazy"
                  />
                </Link>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default PhotographFeed;
